import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.3/js/sparta-global-functions-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.3/js/sparta-ui-layers-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.3.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.5/js/sparta-validation-framework";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import "utilities/vendor/jsencrypt/2.3.1/js/jsencrypt";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.2/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import fingerprintUtility from "utilities/login/fingerprint-utility/2.0.0/js/fingerprint-utility";
import textInput from "utilities/helpers/helpers-text-inputs/4.1.0/js/helpers-text-inputs";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.1/js/sparta-input-utility";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import checkbox from "utilities/helpers/helpers-checkbox/4.2.6/js/helpers-checkbox";
import checkboxHelper from "utilities/helpers/helpers-checkbox/4.2.6/js/helpers-checkbox";
import spartaHelpers from "utilities/helpers/helpers-sparta/2.3.5/js/helpers-sparta";
import radioButton from "utilities/helpers/helpers-radio-button/4.3.1/js/helpers-radio-button";
import select from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import helpersSelect from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import selectHelper from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import textAreaHelper from "utilities/helpers/helpers-textarea/2.1.1/js/helpers-textarea";
import spartaTemplates from "modules/login/ah-secure-signin-module/8.4.1/js/templates";
import "css!modules/login/ah-secure-signin-module/8.4.1/css/ah-secure-signin-module.scss.css";



 export default class ahSecureSigninView {
     constructor(parentModule) {
         console.log('New ahSecureSigninView');
         this.parentModule = parentModule;

         const self = this;
         this.bindThisConext(['_initialize'],
             self, '');


                  }

     bindThisConext(methods, context, suffix = 'Scoped') {
         const self = context;

         if (methods && $.isArray(methods) && methods.length > 0) {
             $(methods).each((index, method) => {
                 if (self[method]) {
                     self[method + suffix] = self[method].bind(context);
                 } else {
                     console.log(`Method: ${method} Not found in current context.`);
                 }
             });
         }
     }

     _defineVars() {
         const _view = this.parentModule.view;
         this.$moduleContext = $(_view.settings.target);

         const elementsID = {
             'main-container': 'ah-secure-signin-container',
             signinMainContent: 'sign-in-main-content',
             saveOnlineID: 'saveOnlineID',
             errorTarget: 'error-target',
             oidTxtBox: 'oid',
             oidPass: 'pass',
             genericErrorSigninSection: 'generic-error-signin-section',
             genericErrorSigninClose: 'generic-error-signin-close',
             captchaContent: 'secure-signin-captcha',
             captchaSubmit: 'submit-captcha',
             captchaImgRefreshBtn: 'captcha-img-refresh-btn',
             captchaAudioBtn: 'captcha-audio-btn',
             captchaError: 'captcha-error',
             captchaAudio: 'captcha-audio',
             captchaInput: 'captchaKey',
             signinWithMobileAppLink: 'signin-with-mobile-app-link',
             signinWithMobileAppLinkText: 'signin-with-mobile-app-link-text',
             signInWithMobileApp: 'signin-with-mobile-app',
             signInWithMobileAppButton: 'signin-with-mobile-app-button',
             mobileDeviceNotificationText: 'mobile-device-notification-text',
             sendNotificationAgain: 'send-notification-again',
             sendNotificationAgainText: 'send-notification-again-text',
             signInWithPasscode: 'signin-with-passcode',
             signInWithPasscodeText: 'signin-with-passcode-text',
             signinWithPasscodeInstead: 'signin-with-passcode-instead',
             signinWithPasscodeTextInstead: 'signin-with-passcode-text-instead',
             mobileDeviceGenericNotificationText: 'mobile-device-generic-notification-text',
             mobileDeviceMaximumAttemptNotificationText: 'mobile-device-maximum-attempt-notification-text',
             passCodeField: 'passCodeField',
             forgotOidPass: 'caw-forgot',
             iaValue: '_ia',
             dropDownOid: 'prefill-oid',
             signIn: 'caw-signin',
             forgotOidPasscode: 'forgot-oid-pass',
             enroll: 'secure-signin-enroll',
             signinSubmit: 'secure-signin-submit',
             xidsigninbtn: 'xid-signin-btn',
             xidcancelbtn: 'xid-cancel-btn'
         };

         const elementsClass = {
             'save-id-wrapper': 'save-id-wrapper',
             'oid-input-wrapper': 'oid-input-wrapper',
             'prefill-oid-wrapper': 'prefill-oid-wrapper',
             btn1stFactorValidate: 'secure-signin-submit',
             cancelSignin: 'secure-signin-cancel',
             cancelbolSignin:'secure-signin-cancel-bol'
         };
         this.elementsSelectors = {};

         $.each(elementsID, (i, val) => {
             this.elementsSelectors[i] = `#${val}`;
         });
         $.each(elementsClass, (i, val) => {
             this.elementsSelectors[i] = `.${val}`;
         });
         return this;

         const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('flow')==="x1"){
            $('#xid-signin').removeClass('hidden');
        }
     }

     _errorInline(title, content) {
         if (!content) {
             content = ' ';
         }
         const spartaMessageUtility = new this.parentModule.Message();
         this.$moduleContext.find(this.elementsSelectors.errorTarget).empty();
         spartaMessageUtility.showErrorMessage(this.elementsSelectors.errorTarget, title, content, { insert: 'replace' });
         if (content === ' ') {
             this.$moduleContext.find('.spartaMessage-icon').removeAttr('style');
             this.$moduleContext.find('.spartaMessage-text').addClass('spartaMessage-no-text').removeClass('spartaMessage-text');
         }
     }

     _bindEventHandlers() {
             const main = this.parentModule;
             const that = this;

             this.$moduleContext.find('#pass').prop('disabled', true);
             $('#oid').bind('keyup paste', (e) => {
                 window.setTimeout(function() {
                     if ($('#oid').val().length < 6) {
                         $('#pass').prop('disabled', true);
                         $('#pass').val('');
                     } else {
                         $('#pass').prop('disabled', false);
                     }
                 }, 1); 

             });
             const prefillOidDropDown = this.$moduleContext.find(this.elementsSelectors['prefill-oid-wrapper']).find('select');

             this.$moduleContext.find(this.elementsSelectors.signInWithMobileApp)
                 .off('click')
                 .on('click', () => {
                     this._handleMobileAppClick();
                 });

              this.$moduleContext.find(this.elementsSelectors.signinWithMobileAppLinkText)
                  .off('click')
                  .on('click', () => {
                    this._handleMobileAppClick();
                  });


             this.$moduleContext.find(this.elementsSelectors.btn1stFactorValidate)
                 .off('click.validate1stFactor')
                 .on('click.validate1stFactor', () => {
                     this._triggerVerifyAuth();
                 });

             this.$moduleContext.find('#enroll-link').on('click', () => {
                 window.top.location = 'https://secure.bankofamerica.com/login/enroll/entry/olbEnroll.go?reason=model_enroll&request_locale=en-us';
             });



             prefillOidDropDown.off('change.triggerInitAuth').on('change.triggerInitAuth', () => {
                 if (prefillOidDropDown.find('option:selected').val() !== 'manual-oid') {
                     this.triggerInitAuth({ selectedOnlineIdIndex: prefillOidDropDown.find('option:selected').val() });
                 }
             });


             const oidInput = this.$moduleContext.find(this.elementsSelectors['oid-input-wrapper']).find('input');
             oidInput.off('blur.triggerInitAuth').on('blur.triggerInitAuth', () => {
                 if (_.trim(oidInput.val()) !== 'manual-oid' && oidInput.val()) {
                     this.triggerInitAuth({ onlineId: oidInput.val() });
                 }
             });


             this.$moduleContext.find(this.elementsSelectors.cancelSignin).off('click').on('click', () => {
               if (main.widgetConfigData && main.widgetConfigData.userData.usecase === 'tokenization') {

                 main.Events.pub('AH_BE_EXECUTE', { "eventType": "Cancel", "eventCode": "" });
               } else {
                 main.Events.pub(cawEventsMasterUtility.EVENTS.AH_AUTH_CANCEL, { reason: 'user-cancel' });
               }
             });

             this.$moduleContext.find(this.elementsSelectors.cancelbolSignin).off('click').on('click', () => {
                 main.Events.pub('OCA_AUTH_CANCEL', { reason: 'user-cancel' });
             });


             this.$moduleContext.find(this.elementsSelectors.genericErrorSigninClose).off('click').on('click', () => {
                 window.location.href = '/login/rest/sas/sparta/secure/v1/oauthRedirect?action=Cancel';
             });


             this.$moduleContext.find(this.elementsSelectors.captchaSubmit).off('click.validateCaptcha').on('click.validateCaptcha', function() {

                 that._validateCaptcha();
             });

             this.$moduleContext.find(this.elementsSelectors.captchaImgRefreshBtn).on('click', function() {
                 that._refreshCaptcha();
             });

             this.$moduleContext.find(this.elementsSelectors.captchaAudioBtn).on('click', function() {
                 that._setCaptchaAudio();
                 that.$moduleContext.find(that.elementsSelectors.captchaAudio)[0].play();
             });


             this.$moduleContext.find(this.elementsSelectors.xidsigninbtn).off('click').on('click', () => {

                            });

            this.$moduleContext.find(this.elementsSelectors.xidcancelbtn).off('click').on('click', () => {
                that._cancelbuttonclickHandler();
            });

             return this;
         }

         _validateOidForDi() {
           const main = this.parentModule;

           const isValid = spartaValidationFramework.fn.core.validateRequiredFields(this.$moduleContext.find('#oid'));

           const isOnlineIDHidden = this.$moduleContext.find(this.elementsSelectors.oidTxtBox).parent('div').parent('div').hasClass('hidden');
           if (!isOnlineIDHidden && !isValid) {
               let useCaseVal = main.Store.getData('widgetConfigData').usecase;
               return isValid;
           }

         this.submitLoader('show');
          main.Events.pub("handleMobileAppLink", "");
         }

         _handleMobileAppClick(e){

              if (e) {
                e.preventDefault();
              }
              this._validateOidForDi();
            }





     triggerInitAuth(data) {
         if (_.isEmpty(_.get(data, 'onlineId')) && _.isEmpty(_.get(data, 'selectedOnlineIdIndex'))) {
             return;
         }
         let inputJson;
         const main = this.parentModule;
         let widgetConfigData = main.Store.getData('widgetConfigData');
         if (this.triggerInitAuthDone === JSON.stringify(data)) {
             return;
         }

         let initClient;
         if (widgetConfigData.usecase === 'tokenization') {
             initClient = 'OAuth';
         } else { 
             initClient = 'BOFA-OLB';
         }
         inputJson = this.getParams('init-auth', data, widgetConfigData);
         this.triggerInitAuthDone = JSON.stringify(data);


         if(widgetConfigData.pid){
             inputJson.partnerId = widgetConfigData.pid;
         }

         if (inputJson) {

             const ajaxOptions = {
                 method: 'POST',
                 data: JSON.stringify(inputJson),
                 url: main.apiEndPoints.initAuthUrl,
                 crossDomain: true,
                 cache: false,
                 timeout: 60000,
                 processData: false,
                 xhrFields: {
                     withCredentials: true,
                 },
                 dataType: 'json',
                 headers: {
                     'content-type': 'application/json',
                     clientAIT: '41339',
                     accept: 'application/json',
                     'cache-control': 'no-cache',
                 },
             };

             const initiateCall = new ahCawTransportUtility();
             const me = this;
             initiateCall._serviceCall(ajaxOptions, (data) => {

                 if (!(me.$moduleContext.find(me.elementsSelectors['prefill-oid-wrapper']).hasClass('hidden'))) {
                     $('#pass').prop('disabled', false);
                 }
                 let widgetInfo = main.Store.getData('widgetConfigData');
                 if(widgetInfo && widgetInfo.originatingFrom === "OCA-GWIM" ){
                     if(data.responseData&&data.responseData.sessionPublicKey){
                        main.Store.addData('encryptKey',data.responseData.sessionPublicKey);
                     }
                 }

                 if (typeof(post_deviceprint) !== 'undefined') {
                     post_deviceprint();
                 }
             });
         }
     }




     _triggerVerifyAuth() {
         const main = this.parentModule;
         const that = this;
         this.$moduleContext.find(this.elementsSelectors.errorTarget).empty();
         const widgetConfigData = main.Store.getData('widgetConfigData');
         let proceedWithSignIn = true;
         if (widgetConfigData && widgetConfigData.preSignInValidate) {
             proceedWithSignIn = widgetConfigData.preSignInValidate();
         }
         if (!proceedWithSignIn) {
             return 'Client Validation Failed.';
         }

         this.$moduleContext.find('.errors-wrapper, .errors-wrapper .error').addClass('hidden');



         let OnlineIDSaved = 'false';
         if (this.$moduleContext.find(this.elementsSelectors.saveOnlineID).is(':checked')) {
             OnlineIDSaved = 'true';
         }


         let _iaData = '';
         const oid = _.trim(this.$moduleContext.find('#oid').val());
         widgetConfigData.oid = oid;
         main.Store.addData('WidgetOidData',widgetConfigData.oid);

         const encryptedOid = main.jsEncrypt.encrypt(oid);
         const encryptedPass = main.jsEncrypt.encrypt(this.$moduleContext.find('#pass').val());

         const isValid = spartaValidationFramework.fn.core.validateRequiredFields(this.$moduleContext.find('[required]:visible'));
         if (!isValid) {
             let useCaseVal = main.Store.getData('widgetConfigData').usecase;
             return isValid;
         }

         let prefillOid = '';
         let clientID, authContext, subChannel, cardPreference = '';
         if (this.$moduleContext.find('#prefill-oid').is(':visible') === true) {
             prefillOid = this.$moduleContext.find('#prefill-oid').val();
         }
         if (window.boa && window.boa.fingerprint) {
             window.boa.fingerprint.prepareIAData((IAData) => {
                 _iaData = IAData;
             });
         }

         if (main.widgetConfigData.userData.usecase === 'tokenization') {
             clientID = 'OAuth';
             authContext = (main.widgetConfigData.userData.scope == 'ewallet.pp') ? "PAYPALPULL" : "AGGREGATOR";
         } else {
             clientID = main.widgetConfigData.userData.clientId;
             authContext = 'OnlineIDPwd';
             if (main.widgetConfigData.userData.usecase === 'signInDITA') {
                 subChannel = spartaStoreUtility.getData('subChannel') !== '' ? spartaStoreUtility.getData('subChannel') : '';
                 cardPreference = spartaStoreUtility.getData('cardPreference') !== '' ? spartaStoreUtility.getData('cardPreference') : '';
             }
             if (main.widgetConfigData.userData.clientId === 'ATP') {
                authContext = "ATPSIGNIN";
             }

         }

         const inputJson = {
             tokenSets: [{
                 value: encryptedPass,
                 type: 'PASSWORD',
             }, ],
             processRules: [{
                     value: authContext,
                     name: 'AuthenticationContext',
                 },
                 {
                     value: OnlineIDSaved,
                     name: 'SAVE_ONLINE_ID',
                 },
                 {
                    "value": navigator.credentials ? "true" :"false",
                    "name": "U2F_SUPPORTED_BROWSER"
                 },
                 {
                     value: _iaData,
                     name: '_ia',
                 },
                 {
                     value: document.referrer,
                     name: '_dr'
                 }
             ],
             filterRules: [{
                     value: 'WEB',
                     name: 'CHANNEL',
                 },
                 {
                     value: main.widgetConfigData.userData.lob,
                     name: 'LOB',
                 },
                 {
                     value: main.widgetConfigData.userData.usecase,
                     name: 'USECASE',
                 },
                 {
                     value: main.widgetConfigData.userData.usecase,
                     name: 'FLOW',
                 },




                 {
                     value: main.widgetConfigData.userData.source,
                     name: 'SOURCE',
                 },
                 {
                     value: subChannel,
                     name: 'SUBCHANNEL'
                 },
                 {
                     value: cardPreference,
                     name: 'CARDPREFERENCE'
                 },
             ],
         };


         if (main.widgetConfigData.userData.client && main.widgetConfigData.userData.client !== '') {
             inputJson.filterRules.push({
                 value: main.widgetConfigData.userData.client,
                 name: 'CLIENT',
             });
         }

         var selectedOid = '';
         if (prefillOid !== '') {
             selectedOid = jQuery('#prefill-oid option:selected').text();
             inputJson.tokenSets.push({
                 value: prefillOid,
                 type: 'OID_INDEX',
             });
         } else {
             selectedOid = oid;
             inputJson.tokenSets.push({
                 value: encryptedOid,
                 type: 'ONLINE_ID',
             });
         }


         const ajaxOptions = {
             method: 'POST',
             data: JSON.stringify(inputJson),
             url: main.apiEndPoints.verifyAuthUrl,
             crossDomain: true,
             cache: false,
             timeout: 60000,
             processData: false,
             xhrFields: {
                 withCredentials: true,
             },
             dataType: 'json',
             headers: {
                 'content-type': 'application/json',
                 clientAIT: '41339',
                 accept: 'application/json',
                 'cache-control': 'no-cache',
             },
         };

         $('#caw-signin #secure-signin-submit').attr('disabled', 'disabled');
         $('#responsive-signin #secure-signin-submit').attr('disabled', 'disabled');
         const initiateCall = new ahCawTransportUtility();
         initiateCall._serviceCall(ajaxOptions, (response) => {
             const data = response.responseData;
             this.triggerInitAuthDone = "";
			 if (data && data.paymentsOAuth) {
                 main.Store.addData('paymentsOAuth', data.paymentsOAuth);
             }
             if (data && data.Completion) {
                 main._debug(`VerifyAuth Success: ${JSON.stringify(data)}`);















				                    data.inputData = data.inputData || {};

                 data.inputData.oid = selectedOid;
                 data.successCallback = main.widgetConfigData.userData.callbackTarget;
                 data.target = main.callbackTarget; 


                 data.otacNamespace = main.otacNamespace;
                 data.supportedNamespaces = main.supportedNamespaces;

                 if (data.Completion.type === 'CAPTCHA') {
                     main.view.emit({ context: 'update-captcha-state', data: { captchaState: true } });
                     main.Events.pub(cawEventsMasterUtility.EVENTS.SIGNIN_CAPTCHA_INIT, data);
                 } else {
                     if (main.captchaState === true) {
                         main.view.emit({ context: 'update-captcha-state', data: { captchaState: false } });
                     }
                     main.Events.pub(cawEventsMasterUtility.EVENTS.FIRST_FACTOR_SUCCESS, data);
                 }


             } else {
                 main._debug(`Verify Failed: ${JSON.stringify(data)}`);

                 that.$moduleContext.find('#oid,#pass').val('');
                 that.$moduleContext.find('#saveOnlineID').attr('checked', false);

                 if (data.errorCode) {
                     let flowName = main.Store.getData('widgetConfigData');

                                                if(flowName && flowName.originatingFrom === 'ATP-CAW' && data.errorCode && data.errorCode === "RESULT_ATP_TEMP_TO_PERM"){

                                                       main.Events.pub(cawEventsMasterUtility.EVENTS.TRIGGER_GWIM_INTERRUPT,data.errorCode);
                            return

                        }  else if (typeof flowName !== "undefined" && flowName.usecase === 'tokenization') {
                         data.origin = "signIn";
                         main.Events.pub("TOKENIZATION_ERROR_HANDLING", data);
                     } else { 
                         if(flowName && flowName.originatingFrom === 'OCA-GWIM'){
                             data.errorCode = "BOL_"+data.errorCode;
                         }else if(flowName &&  flowName.usecase === 'linkBOL'){
                            if(data.errorCode === 'E0029' || data.errorCode === 'E0028'  || data.errorCode === 'E0027'){
                                data.errorCode = 'E0001';
                            }
                         }else if(flowName &&  flowName.originatingFrom === 'ATP-CAW'){
                            if(/^(E0028|E0029|E0008|E0015|E0027|E0007|E0028_.*)$/.test(data.errorCode)){
                                data.errorCode = "ATP-"+data.errorCode;
                            }
                         }
                         const handleErrorResponse = that._handleError(data.errorCode);
                         if (handleErrorResponse && handleErrorResponse.validErrorCode) {
                             if (main.captchaState && main.captchaState === true) {
                                 if (that.$moduleContext.find(that.elementsSelectors.signinMainContent).hasClass('hidden')) {
                                     that.$moduleContext.find(that.elementsSelectors.signinMainContent).removeClass('hidden');
                                 }
                                 if (!that.$moduleContext.find(that.elementsSelectors.captchaContent).hasClass('hidden')) {
                                     that.$moduleContext.find(that.elementsSelectors.captchaContent).addClass('hidden');
                                 }
                             }

                             if (handleErrorResponse.errorType === 'fatal') {
                                 main.Events.pub(cawEventsMasterUtility.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS);
                             }
                         }
                     }
                 }












             }
             $('#caw-signin #secure-signin-submit').removeAttr('disabled');
             $('#responsive-signin #secure-signin-submit').removeAttr('disabled');
         }, () => {
             let flowName = main.Store.getData('widgetConfigData');

             if (typeof flowName !== "undefined" && typeof flowName.lob !== "undefined" && flowName.lob === 'GWIM') {
                 that._errorInline(that.parentModule.errorMessage.data.error.auth['GWIM_GEN_ERROR'].title,
                     that.parentModule.errorMessage.data.error.auth['GWIM_GEN_ERROR'].message ? that.parentModule.errorMessage.data.error.auth['GWIM_GEN_ERROR'].message : null);
             }else if(flowName && flowName.originatingFrom === 'OCA-GWIM'){
                 that._errorInline(that.parentModule.errorMessage.data.error.auth['BOL_GENERAL_ERROR'].title,
                 that.parentModule.errorMessage.data.error.auth['BOL_GENERAL_ERROR'].message ? that.parentModule.errorMessage.data.error.auth['GWIM_GEN_ERROR'].message : null);
             }else {
                 that._errorInline(that.parentModule.errorMessage.data.error.auth['ULTRA_HIGH'].title,
                     that.parentModule.errorMessage.data.error.auth['ULTRA_HIGH'].message ? that.parentModule.errorMessage.data.error.auth['ULTRA_HIGH'].message : null);
             }
             that.$moduleContext.find(that.elementsSelectors.signinMainContent).addClass('hidden');
             main.Events.pub(cawEventsMasterUtility.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS);
             $('#caw-signin #secure-signin-submit').removeAttr('disabled');
             $('#responsive-signin #secure-signin-submit').removeAttr('disabled');
         });
     }

     populateOidDropDown(onlineIdlist) {
         const main = this.parentModule;
         const prefillOidDropDown = this.$moduleContext.find(this.elementsSelectors['prefill-oid-wrapper']).find('select');
         const optionHtml = [];
         for (let i = 0; i < onlineIdlist.length; i++) {
             optionHtml.push(`<option value='${i}'>${onlineIdlist[i]}</option>`);
         }
         prefillOidDropDown.html(optionHtml.join('<br/>'));


         let languageSetting = document.documentElement.lang;
         if (languageSetting.indexOf("en") > -1) {
             $('<option/>').attr({ value:   'manual-oid'  }).text('Use another ID').appendTo(prefillOidDropDown);
         } else if (languageSetting.indexOf("es") > -1) {
             $('<option/>').attr({ value:   'manual-oid'  }).text('Usar otra Identificación en línea').appendTo(prefillOidDropDown);
         }

         prefillOidDropDown.off('change.showOidInput').on('change.showOidInput', () => {
             if (prefillOidDropDown.find('option:selected').val() === 'manual-oid') {
                 this.$moduleContext.find(this.elementsSelectors['oid-input-wrapper']).removeClass('hidden');
                 this.$moduleContext.find(this.elementsSelectors['prefill-oid-wrapper']).addClass('hidden');

                 $('#pass').val('');
                 $('#pass').prop('disabled', true);

                   this.$moduleContext.find(this.elementsSelectors.oidPass).parent('div').removeClass('hidden');
                   this.$moduleContext.find(this.elementsSelectors.oidTxtBox).parent('div').parent('div').removeClass('hidden');
                   this.$moduleContext.find(this.elementsSelectors.signInWithMobileApp).addClass('hidden');
                   this.$moduleContext.find(this.elementsSelectors.signInWithPasscode).addClass('hidden');
                   this.$moduleContext.find(this.elementsSelectors.saveOnlineID).parent('div').removeClass('hidden');

                  document.getElementById('caw-signin').getElementsByClassName("float-left")[0].classList.remove('hidden');
                   if (main.widgetConfigData && main.widgetConfigData.initData && main.widgetConfigData.initData.cawSwitches["caw.digitalid.switch"] === "true"){
                   this.$moduleContext.find(this.elementsSelectors.signinWithMobileAppLink).removeClass('hidden');
                 }
                   this.$moduleContext.find(this.elementsSelectors.enroll).parent('div').addClass('hidden');


             } else {
                 $('#pass').prop('disabled', false);
             }
         });

         prefillOidDropDown.trigger('change');
     }

     _redraw(event, data) {
         const main = this.parentModule;
         main._debug(data);
         let widgetInfo = main.Store.getData('widgetConfigData');
         if (_.get(data, 'userData.sm') === true) {
             data.userData.showSaveOIDCheck = false; 
         }

         if (data && data.userData && (data.userData.showSaveOIDCheck === "true" || data.userData.showSaveOIDCheck === true)) {
             this.$moduleContext.find(this.elementsSelectors['save-id-wrapper']).removeClass('hidden');
         } else {
             this.$moduleContext.find(this.elementsSelectors['save-id-wrapper']).addClass('hidden');
         }


         if (data && data.initData && data.initData.onlineIdlist && data.initData.onlineIdlist.length > 0) {
             this.$moduleContext.find(this.elementsSelectors['oid-input-wrapper']).addClass('hidden');
             this.populateOidDropDown(data.initData.onlineIdlist);
             if ((main.params && main.params.hideSavedID && main.params.hideSavedID === 'true') || (widgetInfo&&widgetInfo.showSaveOIDCheck && widgetInfo.showSaveOIDCheck ==='false' )) {
                 this.$moduleContext.find(this.elementsSelectors['oid-input-wrapper']).removeClass('hidden');
             } else {
                 this.$moduleContext.find(this.elementsSelectors['prefill-oid-wrapper']).removeClass('hidden');
             }
         } else {
             this.$moduleContext.find(this.elementsSelectors['oid-input-wrapper']).removeClass('hidden');
             this.$moduleContext.find(this.elementsSelectors['prefill-oid-wrapper']).addClass('hidden');
         }
         if (data && data.userData && data.userData.customClass) {
             this.$moduleContext.parents('.ah-caw-main-module').addClass(data.userData.customClass);
         }
         if (data && data.userData && data.userData.usecase === 'tokenization') {
             $('#tw-signin-intro, #responsive-signin, #tw-signin-help').removeClass('hidden');
             $('#caw-signin, #enter-credentials-prompt').addClass('hidden');
             $('#oid').prop('placeholder', '').focus();
             $('label[for=oid]').html('Online ID');
             $('#pass').prop({ "placeholder": "", "disabled": false });
             $('.passcode-input-wrapper').removeClass('mb-10').addClass('mb-40');
             $('label[for=pass]').html('Passcode');
             $('#secure-signin-submit').html("Submit");
             $('#responsive-signin a').removeClass('spa-btn--small').addClass('spa-btn--large');

             this.$moduleContext.find(this.elementsSelectors['oid-input-wrapper']).removeClass('hidden');
             this.$moduleContext.find(this.elementsSelectors['prefill-oid-wrapper']).addClass('hidden');
         }

         if (data && data.userData && data.userData.lob === 'GWIM') {
             $('label[for=oid]').html('User ID');
             $('label[for=pass]').html('Password');
         }

                   const checkOnlineIDSaved = this.parentModule.SpartaFunctions.spartaGetCookie('olb_signin_prefill_multi_secure').trim();
         this.$moduleContext.find(this.elementsSelectors['signinMainContent']).removeClass('hidden');
         this.$moduleContext.find(this.elementsSelectors['main-container']).removeClass('hidden');
         this.$moduleContext.find(this.elementsSelectors['captchaContent']).addClass('hidden');

             }

     isDigitalUser(){
       const main = this.parentModule;
	   const checkOnlineIDSaved = main.SpartaFunctions.spartaGetCookie('olb_signin_prefill_multi_secure').trim();
       const pwdlCookie = main.SpartaFunctions.spartaGetCookie('pwdl').trim();
       const onlineIdList = checkOnlineIDSaved.split('||');
       const dropDownOptionElem = document.getElementById("prefill-oid");
       let selectedEncryptedID;
       let selectedID = "";
       if(dropDownOptionElem.value){
       selectedID = dropDownOptionElem.options[dropDownOptionElem.selectedIndex].text;
       for (let i = 0; i < onlineIdList.length; i++){
         let onlineIdsWithEncrypted = onlineIdList[i].split(':');
         if(onlineIdList[i].indexOf(selectedID) > -1){
           selectedEncryptedID = onlineIdList[i].split(':')[1];
         }

       }
       }
       if(selectedID && pwdlCookie && pwdlCookie.indexOf(selectedEncryptedID) > -1){
       return true;
     } else {
       return false;
     }
     }

     submitLoader(state = 'show') {
       const submitButton = document.getElementById('signin-with-mobile-app-button');
       if (state === 'show') {
         submitButton.classList.add('loading');
       } else {
         submitButton.classList.remove('loading');
       }
     }

     redrawForDigitalID(){

       const main = this.parentModule;
       let widgetInfo = main.Store.getData('widgetConfigData');
       const dropDownOptionElem = document.getElementById("prefill-oid");
       const selectedID = dropDownOptionElem.options[dropDownOptionElem.selectedIndex];
       const prefillOidDropDown = this.$moduleContext.find(this.elementsSelectors['prefill-oid-wrapper']).find('select');
       this.$moduleContext.find(this.elementsSelectors.signIn).removeClass('hidden');
       this.submitLoader('hide');

       if(this.isDigitalUser()){
         if (widgetInfo && widgetInfo.showSaveOIDCheck && widgetInfo.showSaveOIDCheck ==='false' ){
          this.$moduleContext.find(this.elementsSelectors.signInWithMobileApp).addClass('hidden');
          this.$moduleContext.find(this.elementsSelectors.signInWithPasscode).addClass('hidden');
          this.$moduleContext.find(this.elementsSelectors.oidPass).parent('div').removeClass('hidden');
          this.$moduleContext.find(this.elementsSelectors.saveOnlineID).parent('div').addClass('hidden');
          this.$moduleContext.find(this.elementsSelectors.dropDownOid).parent('div').addClass('hidden');
          this.$moduleContext.find(this.elementsSelectors.signinWithMobileAppLink).removeClass('hidden');
          this.$moduleContext.find(this.elementsSelectors.signinWithPasscodeInstead).addClass('hidden');

         document.getElementById('caw-signin').getElementsByClassName("float-left")[0].classList.remove('hidden');
         this.$moduleContext.find(this.elementsSelectors.signinSubmit).parent('div').addClass('hidden');
          this.$moduleContext.find(this.elementsSelectors.mobileDeviceNotificationText).addClass('hidden');
          this.$moduleContext.find(this.elementsSelectors.mobileDeviceMaximumAttemptNotificationText).addClass('hidden');
          this.$moduleContext.find(this.elementsSelectors.mobileDeviceGenericNotificationText).addClass('hidden');
        } else {
         this.$moduleContext.find(this.elementsSelectors.signInWithMobileApp).removeClass('hidden');
         this.$moduleContext.find(this.elementsSelectors.signInWithPasscode).removeClass('hidden');
         this.$moduleContext.find(this.elementsSelectors.oidPass).parent('div').addClass('hidden');
         this.$moduleContext.find(this.elementsSelectors.saveOnlineID).parent('div').addClass('hidden');
         this.$moduleContext.find(this.elementsSelectors.dropDownOid).parent('div').removeClass('hidden');
         this.$moduleContext.find(this.elementsSelectors.signinWithMobileAppLink).addClass('hidden');
         this.$moduleContext.find(this.elementsSelectors.signinWithPasscodeInstead).addClass('hidden');

        document.getElementById('caw-signin').getElementsByClassName("float-left")[0].classList.add('hidden');
        this.$moduleContext.find(this.elementsSelectors.signinSubmit).parent('div').addClass('hidden');
         this.$moduleContext.find(this.elementsSelectors.mobileDeviceNotificationText).addClass('hidden');
         this.$moduleContext.find(this.elementsSelectors.mobileDeviceMaximumAttemptNotificationText).addClass('hidden');
         this.$moduleContext.find(this.elementsSelectors.mobileDeviceGenericNotificationText).addClass('hidden');
       }
     } else {

           if(main.widgetConfigData && main.widgetConfigData.initData && main.widgetConfigData.initData.cawSwitches["caw.digitalid.switch"] === "true"){
       if (selectedID && (prefillOidDropDown.find('option:selected').val() !== 'manual-oid')){

          if ((main.params && main.params.hideSavedID && main.params.hideSavedID === 'true') || (widgetInfo && widgetInfo.showSaveOIDCheck && widgetInfo.showSaveOIDCheck ==='false' )) {
              this.$moduleContext.find(this.elementsSelectors.dropDownOid).parent('div').addClass('hidden');
              this.$moduleContext.find(this.elementsSelectors.oidTxtBox).parent('div').parent('div').removeClass('hidden');
               this.$moduleContext.find(this.elementsSelectors.saveOnlineID).parent('div').removeClass('hidden');
          } else {
              this.$moduleContext.find(this.elementsSelectors.dropDownOid).parent('div').removeClass('hidden');
              this.$moduleContext.find(this.elementsSelectors.oidTxtBox).parent('div').parent('div').addClass('hidden');
               this.$moduleContext.find(this.elementsSelectors.saveOnlineID).parent('div').addClass('hidden');
          }

       } else {

           this.$moduleContext.find(this.elementsSelectors.dropDownOid).parent('div').addClass('hidden');
            this.$moduleContext.find(this.elementsSelectors.oidTxtBox).parent('div').parent('div').removeClass('hidden');
             this.$moduleContext.find(this.elementsSelectors.saveOnlineID).parent('div').removeClass('hidden');
       }

       this.$moduleContext.find(this.elementsSelectors.oidPass).parent('div').removeClass('hidden');
       this.$moduleContext.find(this.elementsSelectors.sendNotificationAgain).addClass('hidden');
       this.$moduleContext.find(this.elementsSelectors.signInWithPasscode).addClass('hidden');
       this.$moduleContext.find(this.elementsSelectors.mobileDeviceNotificationText).addClass('hidden');
       this.$moduleContext.find(this.elementsSelectors.signinWithMobileAppLink).removeClass('hidden');
       this.$moduleContext.find(this.elementsSelectors.signInWithMobileApp).addClass('hidden');
       document.getElementById('caw-signin').getElementsByClassName("float-left")[0].classList.remove('hidden');
       this.$moduleContext.find(this.elementsSelectors.signinWithPasscodeInstead).addClass('hidden');
       this.$moduleContext.find(this.elementsSelectors.mobileDeviceMaximumAttemptNotificationText).addClass('hidden');
       this.$moduleContext.find(this.elementsSelectors.mobileDeviceGenericNotificationText).addClass('hidden');
       document.getElementById("caw-forgot").classList.remove('hidden');
       this.$moduleContext.find(this.elementsSelectors.enroll).parent('div').addClass('hidden');

     }

   }

   }

     _subscribeEvents() {
         const main = this.parentModule;
         const controller = this.parentModule.controller;

         main._debug(`Subscribing to: ${cawEventsMasterUtility.EVENTS.FIRST_FACTOR_CLEANUP}`);

         main.Events.sub(cawEventsMasterUtility.EVENTS.FIRST_FACTOR_CLEANUP, () => {
             main._debug('Cleaning-up SignIn module: ');
             this.$moduleContext.find(this.elementsSelectors['main-container']).addClass('hidden');
         });

         main.Events.sub('Error-Data', (e) => {
             main.errorMessage = e;
         });


         main.Events.sub('AH_UNIVERSAL_OTP_INIT', () => {
             main.Events.pub('AH_UNIVERSAL_OTP_INITIATE');
         });


         main.Events.sub(cawEventsMasterUtility.EVENTS.LOAD_REQUIRED_JS, () => {
             if (this.$moduleContext.find(this.elementsSelectors['main-container']).data('required-js-loaded') !== true) {
                 main._debug('Loading required js: ');


               if (main.widgetConfigData && main.widgetConfigData.userData.usecase === 'tokenization') {
                delete main.jsSrc['cau-login']
              }

                 ahCawCommons.includeExternalResources('script', main.jsSrc, () => {
                     this.$moduleContext.find(this.elementsSelectors['main-container']).data('required-js-loaded', true);
                     const  JSEncrypt  =  new  JSEncryptExports.JSEncrypt();
                     JSEncrypt.setPublicKey(main.publicKey);
                     main.jsEncrypt  =  JSEncrypt;
                 });

             }
         });

         main.Events.sub(cawEventsMasterUtility.EVENTS.INTERNAL.CLEANUP, () => {
             this.$moduleContext.find('#oid,#pass').val('');
             this.$moduleContext.find('#saveOnlineID').attr('checked', false);
             this.$moduleContext.find(this.elementsSelectors.errorTarget).empty();

             this.$moduleContext.find('#oid,#pass').each(function() {
                 const oErrorData = spartaValidationFramework.fn.core.collectErrorData($(this));
                 $(this).removeClass('spa-error-form-input--validation spa-error-form-input--required');
                 oErrorData.label.removeClass('spa-error-form-label--validation spa-error-form-label--required');
                 const sErrorMessageContainderId = `${oErrorData.field.attr('id')}_errorMessage`;
                 const $errorMessageContainer = $(`#${sErrorMessageContainderId}`);

                 oErrorData.field.removeAttr('aria-describedby aria-invalid');
                 $errorMessageContainer.attr('aria-hidden', true);
                 $errorMessageContainer.empty();
             });
         });

         main.Events.sub(cawEventsMasterUtility.EVENTS.SIGNIN_CAPTCHA_INIT, (e) => {
             this._initCaptcha();
         });


                  main.Events.sub(cawEventsMasterUtility.EVENTS.SIGNIN_CAPTCHA_SUCCESS, (e) => {
             this.$moduleContext.find(this.elementsSelectors.captchaContent).removeClass('hidden');
             this._triggerVerifyAuth();
         });

         main.Events.sub(cawEventsMasterUtility.EVENTS.SIGNIN_CAPTCHA_FAILURE, (e) => {
             this._errorInline(this.parentModule.errorMessage.data.error.captcha['FAILURE'].title,
                 this.parentModule.errorMessage.data.error.captcha['FAILURE'].message ? this.parentModule.errorMessage.data.error.captcha['FAILURE'].message : null);
             this.$moduleContext.find(this.elementsSelectors.captchaContent).addClass('hidden');
         });

         main.Events.sub('diChangeOid', () => {
             this.redrawForDigitalID();
         });

         return this;
     }

     getParams(useCase, data, widgetConfigData) {
         let inputJson = {}

         if (useCase === 'init-auth') {
             const main = this.parentModule;

             if (data && data.selectedOnlineIdIndex) {
                 inputJson = {
                     onlineIdIndex: data.selectedOnlineIdIndex,
                     filterRules: [{
                         value: widgetConfigData.usecase,
                         name: 'USECASE'
                     }]
                 };

                 if (widgetConfigData.client && widgetConfigData.client !== '') {
                     inputJson.filterRules.push({
                         value: widgetConfigData.client,
                         name: 'CLIENT',
                     });
                     inputJson.filterRules.push({
                         value: widgetConfigData.usecase,
                         name: 'FLOW',
                     });
                 }

             } else if (data && data.onlineId) {
                 inputJson = {
                     onlineId: main.jsEncrypt.encrypt(_.trim(data.onlineId)),
                     filterRules: [{
                         value: widgetConfigData.usecase,
                         name: 'USECASE'
                     }]
                 };

                 if (widgetConfigData.client && widgetConfigData.client !== '') {
                     inputJson.filterRules.push({
                         value: widgetConfigData.client,
                         name: 'CLIENT',
                     });
                     inputJson.filterRules.push({
                         value: widgetConfigData.usecase,
                         name: 'FLOW',
                     });
                 }
             }
         } 
         return inputJson;
     }

     _listen() {
         const _view = this.parentModule.view;
         _view.listen({ context: 'redraw-widget', caller: this, callback: this._redraw });
         _view.listen({ context: 'redrawForDigitalID', caller: this, callback: this.redrawForDigitalID });
         return this;
     }

     _initialize() {
         this._defineVars()
             ._bindEventHandlers()
             ._subscribeEvents()
             ._listen()
             .isDigitalUser();

         const basePath = ahCawCommons.getBasePath(this.parentModule.spaParams);

         this.$moduleContext.find('[data-href]').each(function() {
             $(this).attr('href', basePath + $(this).attr('data-href'));
         });

     }


     _initCaptcha() {

         const _this = this;
         const main = this.parentModule;
         let displayCaptchaURL = main.apiEndPoints.displayCaptcha;
         _this.$moduleContext.find(_this.elementsSelectors.signinMainContent).addClass('hidden');
         _this.$moduleContext.find(_this.elementsSelectors.captchaContent).removeClass('hidden');
         _this._setCaptchaImageText();
     }

     _setCaptchaImageText() {
         const main = this.parentModule;
         let generateCaptchaImgURL = main.apiEndPoints.generateTextCaptcha + "?f=" + (new Date()).getTime();
         $('#image-text').attr('src', '#').attr('src', generateCaptchaImgURL).removeClass('hidden');
     }

     _setCaptchaAudio() {
         const main = this.parentModule;
         let generateCaptchaAudioURL = main.apiEndPoints.generateAudioCaptcha;
         this.$moduleContext.find(this.elementsSelectors.captchaAudio).attr('src', generateCaptchaAudioURL);
     }

     _refreshCaptcha() {
         this._setCaptchaImageText();
     }


         _handleError(errorCode) {
         const defaultConfig = {
             '$moduleContext': this.$moduleContext,
             'basePath': this.parentModule.basePath,
             'mainContainer': this.elementsSelectors.signinMainContent,
             'messageUtility': new this.parentModule.Message(),
             'errorTarget': this.elementsSelectors.errorTarget
         }

         return ahCawCommons.handleError(this.parentModule.errorMessage.data.error.auth,
             Object.assign({}, defaultConfig, { 'errorCode': errorCode })
         );
     }

     _validateCaptcha() {
         const that = this;
         const main = this.parentModule;
         let validateCaptchaURL = main.apiEndPoints.validateCaptcha2;
         var captchaKey = this.$moduleContext.find(this.elementsSelectors.captchaInput)[0].value;
         this.$moduleContext.find(this.elementsSelectors.captchaInput).val("");
         let validateResult;
         let inputJson = { captchaCode:captchaKey };

         const ajaxOptions = {
             method: 'POST',
             data: JSON.stringify(inputJson),
             url: validateCaptchaURL,
             crossDomain: true,
             cache: false,
             timeout: 60000,
             processData: false,
             xhrFields: {
                 withCredentials: true,
             },
             dataType: 'json',
             headers: {
                 'content-type': 'application/json',
                 clientAIT: '41339',
                 accept: 'application/json',
                 'cache-control': 'no-cache',
             },
         };

  const initiateCall = new ahCawTransportUtility();
         const me = this;
         initiateCall._serviceCall(ajaxOptions, (response) => {
         validateResult = response.responseData.status;
         let validateError = response.responseData.errorInfo;
         if (validateResult){
             if (validateResult.toUpperCase() === "SUCCESS") {
                 main.Events.pub(cawEventsMasterUtility.EVENTS.SIGNIN_CAPTCHA_SUCCESS);
             } else if (validateResult.toUpperCase() === "RETRY") {
                 that._errorInline(main.errorMessage.data.error.captcha['RETRY'].title,
                     main.errorMessage.data.error.captcha['RETRY'].message ? main.errorMessage.data.error.captcha['RETRY'].message : null);
                 that._setCaptchaImageText();
                }
            }
           else if (validateError) {
                 main.Events.pub(cawEventsMasterUtility.EVENTS.SIGNIN_CAPTCHA_FAILURE);
             }
            }, () => {
             main.Events.pub(cawEventsMasterUtility.EVENTS.SIGNIN_CAPTCHA_FAILURE);
         });

     }



  _cancelbuttonclickHandler() {
    const that = this;
    console.log("Cancel button click handler to sign in flow");
        const ajaxOptions = {
        method: 'GET',
        data: JSON.stringify({
            "reason": "timeout"
        }),
        url: this.url.cancelXid,
        crossDomain: true,
        cache: false,
        timeout: 60000,
        processData: false,
        xhrFields: {
            withCredentials: true,
        },
        headers: {
            'content-type': 'application/json',
            accept: 'application/json',
            'cache-control': 'no-cache'
        },
        dataType: 'json'
        };

        const initiateCall = new ahCawTransportUtility();

                initiateCall._serviceCall(ajaxOptions, (response) => {

        if(response && response.result === "success"){
            console.log("Get Consent cancel is successful.");
        }else{
            if (response.errorInfo) {
            console.log("cancel call service error"); 
        }

        }
        },(error)=>{
            console.log("cancel call service got error.");
        });

    }

 }
